import React from 'react';
import { Icon } from '@fourthwall/components';
import { ArrowShortLeftIcon } from '@fourthwall/icons';
import { getBreadcrumbsString, getDirectParentFromBreadcrumbs } from '../../../../utils/breadcrumbs';
import * as S from './styled';
export const Header = ({ selectedCategory, focused = false, onClick }) => {
    const hasChildren = selectedCategory.children.length > 0;
    return (React.createElement(S.Container, { tabIndex: -1, onClick: onClick, "$focused": focused },
        React.createElement(S.IconContainer, null,
            React.createElement(Icon, { component: ArrowShortLeftIcon, height: 12 })),
        React.createElement(S.Content, null,
            React.createElement(S.MainCategory, null, hasChildren
                ? selectedCategory.name
                : getDirectParentFromBreadcrumbs(selectedCategory.breadcrumbs)),
            React.createElement(S.Subcategories, null, getBreadcrumbsString(selectedCategory.breadcrumbs, hasChildren ? 1 : 2)))));
};
